// These should match AntD Alert's "type" prop
export const LEVEL_INFO = 'info';
export const LEVEL_WARN = 'warning';
export const LEVEL_ERROR = 'error';
